export const mobileMedia = '(max-width: 500px)'
export const tabletMedia = '(max-width: 1000px)'
